
export const validateExpiredCard = (item: any, ): any=> {
  if (item.expYear < 2000) item.expYear += 2000;
  const today = new Date();
  const expDate = new Date(item.expYear, item.expMonth -1);
  const todayTemp = new Date(today.getFullYear(), today.getMonth());
  return {...item, expired: todayTemp > expDate};
};
